/* eslint-disable import/no-cycle */
import React from 'react'

import { defaultLanguage } from '../../utils/appConfig'
import {
  ALLOWED_WORDS,
  ContentParser,
  replaceWordInString,
} from '../../utils/helpers'
import { CtaButton } from '..'
import LinkComponent from '../LinkComponent/LinkComponent'
import richTextRenderer from '../RichTextParser/RichTextParser'
import { Kicker } from '../Typography'
import {
  active,
  ctaContainer,
  treatmentCard,
  treatmentCardContent,
  treatmentCardTitle,
} from './TreatmentItem.module.css'

const NewTreatmentItem = ({
  activeTreatment,
  extraClassName,
  lang,
  treatment,
}) => {
  const { treatmentscontent, treatmentspages, treatmentstitle } = treatment
  const ctas = ContentParser(treatment, 'treatmentscta')

  return (
    <div
      className={`${treatmentCard} ${
        activeTreatment === treatmentstitle ? active : ''
      }`}
    >
      {treatmentstitle && (
        <h3 className={treatmentCardTitle}>
          {replaceWordInString(treatmentstitle, 'botox', ALLOWED_WORDS[lang])}
        </h3>
      )}
      {treatmentscontent && (
        <div className={treatmentCardContent}>
          {richTextRenderer(
            replaceWordInString(
              treatmentscontent,
              'botox',
              ALLOWED_WORDS[lang],
            ),
          )}
        </div>
      )}
      {treatmentspages &&
        treatmentspages.nodes.map((treatmentPage, index) => {
          const name = treatmentPage.pageType.name || treatmentPage.title
          return (
            // eslint-disable-next-line react/no-array-index-key
            <Kicker key={index} extraClassName={extraClassName}>
              <LinkComponent
                src={
                  lang === defaultLanguage.slice(0, 2)
                    ? `/${treatmentPage.pageType.uri}/`
                    : `/${lang.slice(0, 2)}/${treatmentPage.pageType.uri}/`
                }
              >
                {name}
              </LinkComponent>
            </Kicker>
          )
        })}
      <div className={ctaContainer}>
        {ctas.length > 0 &&
          ctas.map((cta, index) => {
            let ctaContent = cta
            if (typeof cta === 'string') {
              ctaContent = JSON.parse(cta)
            }
            return (
              <CtaButton key={`cta-${cta?.title || index}`} {...ctaContent} />
            )
          })}
      </div>
    </div>
  )
}

export default NewTreatmentItem
